module.exports = __webpack_public_path__ + "static/media/ISectionGeometry.3facfb66.svg";